import React from 'react';
import IconPicker from '../../../../IconPicker';
import PhoneInput from 'react-phone-number-input';
import ButtonPreview from '../../ButtonPreview';
import { settingsFunctions } from '../../../../../functions/settings';
import 'react-phone-number-input/style.css';
import styles from './ButtonTypeReturn.module.css';

function ButtonTypeReturn(props) {    
    const { addObj, setAddObj, profile_theme } = props;

    const { buttonRefArr } = settingsFunctions;

    const handleInput = e => {
        setAddObj(prev => ({
            ...prev,
            data: addObj.type.ref === 'phone' ? e : e.target.value,
            hasChanges: true
        }));
    };

    const handleIcon = (icon) => {
        if (icon === addObj.icon) {
            setAddObj(prev => ({ ...prev, hasChanges: prev?.hasChanges || false }));
        } else {
            setAddObj(prev => ({ ...prev, icon: icon, hasChanges: true }));
        };
    };

    return (
        <div className={styles.container}>
            <ButtonPreview reference={addObj.type.ref} data={addObj.data} icon={addObj.icon} label={addObj.label} profile_theme={profile_theme} />
            <div className={styles.inputGroup} style={{marginTop: '1.5rem'}}>
                <input
                    type="text"
                    id={`${addObj.type.ref}Temp`}
                    className={styles.input}
                    value={addObj.label}
                    onChange={e => setAddObj(prev => ({...prev, label: e.target.value, hasChanges: true}))}
                    placeholder="Create a custom label for your button!"
                    maxLength='25'
                />
                <label htmlFor={`${addObj.type.ref}Temp`} className={styles.label}>Label (Optional)</label>
            </div>
            <div className={styles.inputGroup}>
                {addObj.type.ref === 'phone' ? 
                    <>
                    <PhoneInput
                        id="add-button-phone"
                        international
                        className={styles.phoneInput}
                        countryCallingCodeEditable={false}
                        placeholder='Enter phone number.'
                        defaultCountry='US'
                        value={addObj.data.replaceAll(' ','')}
                        onChange={handleInput}
                    />
                    <label htmlFor='add-button-phone' className={styles.phoneLabel}>{`${addObj.type.label}`}</label>
                    </>
                :
                    <>
                    <input
                        type={addObj.type.ref === 'email' ? 'email' : buttonRefArr.includes(addObj.type.ref) ? 'text' : 'url'}
                        id={`add-button-${addObj.type.ref}`}
                        className={styles.input}
                        value={addObj.data}
                        onChange={handleInput}
                        pattern={addObj.type.ref !== 'email' && !buttonRefArr.includes(addObj.type.ref) ? "(^((https|http)://)?[a-z0-9]+.[a-z]+(/[a-zA-Z0-9#]+/?)*$)|^((https|http)://)?(www.)?[a-z0-9]+.[a-z]+(/[a-zA-Z0-9#]+/?)*$" : null}
                    />
                    <label htmlFor={`add-button-${addObj.type.ref}`} className={styles.label}>{addObj.type.label}</label>
                    </>
                }
            </div>
            <div className={styles.inputGroup}>
                <IconPicker handleIcon={handleIcon} prevIcon={addObj?.icon} />
            </div>
        </div>
    );
};

export default ButtonTypeReturn;